import { NavLink, useLocation } from 'react-router-dom'
import { DripCampaigns } from './DripCampaigns'
import { Workflows } from './Workflows'

// A drip is not a different kind of thing from a workflow. `crm_drip.playbook`
// holds a workflow key, launching one writes ordinary rows into `crm_enrollment`,
// and the same runner walks them — the only additions are an audience, a pace and
// the rules for stopping. So: one place, with the library on one tab and the
// campaigns running out of it on the other.
//
// Both routes still resolve here, so links and bookmarks to /drips keep working.
export function WorkflowsHome() {
  const campaigns = useLocation().pathname.startsWith('/drips')
  return (
    <>
      <div className="page" style={{ paddingBottom: 0 }}>
        <div className="tabs" style={{ marginTop: 0 }}>
          <NavLink to="/workflows" className={`tab${campaigns ? '' : ' active'}`}>Workflows</NavLink>
          <NavLink to="/drips" className={`tab${campaigns ? ' active' : ''}`}>Campaigns</NavLink>
        </div>
      </div>
      {campaigns ? <DripCampaigns /> : <Workflows />}
    </>
  )
}
